import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';

import { RootState } from 'store/store';

import { dashboardOverviewState } from './dashboardOverviewState';
import { DashboardOverviewState } from '../types';

export const dashboardOverviewSlice = createSlice({
  name: 'dashboardOverview',
  initialState: dashboardOverviewState,
  reducers: {
    setDateRange(
      state,
      action: PayloadAction<DashboardOverviewState['dateRange']>,
    ) {
      state.dateRange = action.payload;
    },
    setTerminal(
      state,
      action: PayloadAction<DashboardOverviewState['terminal']>,
    ) {
      state.terminal = action.payload;
    },
    setGranularity(
      state,
      action: PayloadAction<DashboardOverviewState['granularity']>,
    ) {
      state.granularity = action.payload;
    },
    setDataReset: () => dashboardOverviewState,
  },
});

export const { actions: dashboardOverviewActions } = dashboardOverviewSlice;

export const selectDashboardOverview = (state: RootState) =>
  state.dashboardOverview || dashboardOverviewState;

export const makeSelectDateRange = () =>
  createSelector(
    selectDashboardOverview,
    dashboardOverview => dashboardOverview.dateRange,
  );

export const makeSelectTerminal = () =>
  createSelector(
    selectDashboardOverview,
    dashboardOverview => dashboardOverview.terminal,
  );

export const makeSelectGranularity = () =>
  createSelector(
    selectDashboardOverview,
    dashboardOverview => dashboardOverview.granularity,
  );

export default dashboardOverviewSlice.reducer;
